import { AUTH0_COOKIES_PREFIX, ABF_GROUP_HEADER, ABF_GROUP_COOKIE_PREFIX } from "@bridgesplit/abf-react";
import { getBearerToken } from "@bridgesplit/react";
import axios from "axios";

export const axiosTestingInstance = axios.create({
    headers: {
        Authorization: getBearerToken(AUTH0_COOKIES_PREFIX)
            ? `Bearer ${getBearerToken(AUTH0_COOKIES_PREFIX)}`
            : undefined,
        [ABF_GROUP_HEADER]: getBearerToken(ABF_GROUP_COOKIE_PREFIX)
    }
});
